// todo создать  entity FileItem, внутри определить model и перенести туда

export const iconsData = [
    {
        extension: 'pdf',
        iconName: 'pdfFile',
    },
    {
        extension: 'doc',
        iconName: 'docFile',
    },
    {
        extension: 'docx',
        iconName: 'docFile',
    },
    {
        extension: 'xls',
        iconName: 'xlsFile',
    },
    {
        extension: 'xlsx',
        iconName: 'xlsFile',
    },
    {
        extension: 'xml',
        iconName: 'xmlFile',
    },
    {
        extension: 'ifc',
        iconName: 'ifcFile',
    },
    {
        extension: 'ppt',
        iconName: 'pptFile',
    },
    {
        extension: 'pptx',
        iconName: 'pptFile',
    },
    {
        extension: 'csv',
        iconName: 'csvFile',
    },
    {
        extension: 'txt',
        iconName: 'txtFile',
    },
    {
        extension: 'mp4',
        iconName: 'mp4File',
    },
    {
        extension: 'mov',
        iconName: 'movFile',
    },
    {
        extension: 'mp3',
        iconName: 'mp3File',
    },
    {
        extension: 'smtr',
        iconName: 'smtrFile',
    },
    {
        extension: 'rar',
        iconName: 'rarFile',
    },
    {
        extension: 'zip',
        iconName: 'zipFile',
    },
    {
        extension: 'avi',
        iconName: 'aviFile',
    },
    {
        extension: '7z',
        iconName: 'sevenZFile',
    },
    {
        extension: 'default',
        iconName: 'fileItemPlaceholder',
    },
];
